"use client";

import {
  createContext,
  useContext,
  useMemo,
  type ReactNode,
} from "react";
import type { DefModelCnfState } from "@/lib/api/filter-options";
import { DEFAULT_FILTER_OPTIONS } from "@/lib/api/filter-options";

const DefModelCnfContext = createContext<DefModelCnfState | null>(null);

const defaultState: DefModelCnfState = {
  filterOptions: DEFAULT_FILTER_OPTIONS,
  companyById: {},
  authorById: {},
  seriesById: {},
};

export function DefModelCnfProvider({
  value,
  children,
}: {
  value: DefModelCnfState | null;
  children: ReactNode;
}) {
  const state = useMemo(
    () => (value ? value : defaultState),
    [value]
  );
  return (
    <DefModelCnfContext.Provider value={state}>
      {children}
    </DefModelCnfContext.Provider>
  );
}

export function useDefModelCnf(): DefModelCnfState {
  const ctx = useContext(DefModelCnfContext);
  return ctx ?? defaultState;
}
